<template>
  <div>
    <h1 class="page-header">Our Services</h1>
    <template v-if="$store.state.country == 'us'">
      <div class="row">
        <div class="col-md-8">
          <h2>American Philanthropists</h2>
          <p>
            The key to an efficient system requires adherence to all details,
            both large and small. Ne’eman Foundation USA maintains offices in
            both the U.S. and Israel to ensure that all donations arrive at the
            intended destinations, per the donors’ wishes, as soon as possible.
          </p>
          <p>
            Ne’eman Foundation USA, from its American and Israeli offices, also
            monitors the institutions and projects to ensure all requirements
            are fulfilled under the U.S. tax legislation.
          </p>
          <p>
            Donors are secure in the knowledge that their tax-deductible gifts
            will arrive in Israel promptly, allowing their money to go to work
            as soon as possible. They are also assured that there is a
            professional with whom they can always speak in the U.S. and Israel.
          </p>
          <p>
            Full accountability, accessibility and compliance with the American
            tax laws – these are the cornerstones upon which Ne’eman Foundation
            USA is built.
          </p>
          <p>
            <strong
              >Please <a href="/projects/">Click HERE</a>&nbsp;to check out our
              list of worthy non-profit organizations in Israel.</strong
            >
          </p>
          <h2>Israeli Non-Profit Organizations</h2>
          <p>
            Are you a registered non-profit organization in Israel?<br />
            Do you have worthy projects that could interest American donors?<br />
            Discover American philanthropy.
          </p>
          <p>
            Ne’eman Foundation USA assists Israeli organizations to ensure that
            their process and documentation conform to the rules prescribed
            under U.S. tax legislation so that their projects maintain their
            tax-deductible status for American donors.
          </p>
          <p>
            For most Israeli projects, time is critical! Funds are needed as
            soon as possible. Donations received in the U.S. are dealt with
            expediently. Receipts are issued to American donors within 30 days
            of receipt of the funds.
          </p>
          <p>
            <strong
              >For more information –
              <router-link to="/contact" class="text-reset"
                >Click HERE</router-link
              ></strong
            >
          </p>
          <p>
            <strong
              >To join Neeman Foundation USA, please
              <router-link to="/join-us" class="text-reset"
                >Click HERE</router-link
              ></strong
            >
          </p>
        </div>
        <aside id="sidebar" class="col-md-4">
          <div class="card">
            <div class="card-body">
              <strong><u>Check Donation</u></strong> <br />May be sent to the
              Ne'eman Foundation USA office in <strong>USA</strong>:
              <br /><br />
              Ne'eman Foundation USA<br />
              867 Boylston Street<br />
              5th Floor #1342<br />
              Boston, MA 02116<br />
              USA<br /><br /><strong>Telephone:</strong>1(888) 341-8590<br />
              <br />
              <strong>Or</strong> to the Ne'eman Foundation USA office in
              <strong>Israel</strong>:<br /><br />
              Avnei Hachoshen 21,<br />
              Shilo 4483000 Israel<br /><br /><strong>Telephone:</strong>
              +972-(02) 585-6616
            </div>
          </div>
        </aside>
      </div>
    </template>
    <template v-else>
      <div class="row">
        <div class="col-8">
          <h2>Canadian Philanthropists</h2>
          <p>
            The key to an efficient system requires adherence to all details,
            both large and small. The Ne’eman Foundation maintains offices in
            both Canada and Israel to ensure that all donations arrive at the
            intended destinations, per the donors’ wishes, as soon as possible.
          </p>
          <p>
            The Ne’eman Foundation, from its Canadian and Israeli offices, also
            monitors the institutions and projects to ensure all requirements
            are fulfilled under the Canadian tax legislation.
          </p>
          <p>
            Donors are secure in the knowledge that their tax-deductible gifts
            will arrive in Israel promptly, allowing their money to go to work
            as soon as possible. They are also assured that there is a
            professional with whom they can always speak in Canada and Israel.
          </p>
          <p>
            Full accountability, accessibility and compliance with the Canadian
            tax laws – these are the cornerstones upon which the Ne’eman
            Foundation is built.
          </p>

          <p>
            <strong
              >Please <a href="/projects/">Click HERE</a>&nbsp;to check out our
              list of worthy non-profit organizations in Israel.</strong
            >
          </p>
          <h2>Israeli Non-Profit Organizations</h2>
          <p>
            Are you a registered non-profit organization in Israel?<br />
            Do you have worthy projects that could interest Canadian donors?<br />
            Discover Canadian philanthropy.
          </p>
          <p>
            The Ne’eman Foundation assists Israeli organizations to ensure that
            their process and documentation conform to the rules prescribed
            under the Canadian tax legislation so that their projects maintain
            their tax-deductible status for Canadian donors.
          </p>
          <p>
            For most Israeli projects, time is critical! Funds are needed as
            soon as possible. Donations received in Canada are dealt with
            expediently. Receipts are issued to Canadian donors within 30 days
            of receipt of the funds.
          </p>
          <p>
            <strong
              >For more information –
              <router-link to="/contact" class="text-reset"
                >Click HERE</router-link
              ></strong
            >
          </p>
          <p>
            <strong
              >To join Neeman Foundation Canada, please
              <router-link to="/join-us" class="text-reset"
                >Click HERE</router-link
              ></strong
            >
          </p>
        </div>
        <aside id="sidebar" class="col-md-4">
          <div class="card">
            <div class="card-body">
              <strong><u>Check Donation</u></strong> <br />May be sent The
              Ne'eman Foundation's office in <strong>Canada</strong>:
              <br /><br />
              The Ne'eman Foundation<br />
              160 Faywood Blvd.
              <br />
              Toronto, ON M3H 2X9<br />
              Canada<br /><br /><strong>Telephone:</strong>1(888) 341-8590<br />
              <br />
              <strong>Or</strong> to the Ne'eman Foundation Canada office in
              <strong>Israel</strong>:<br /><br />
              P.O.B. 28376Avnei Hachoshen 21,<br />
              Shilo 4483000 Israel<br /><br /><strong>Telephone:</strong>
              +972-(02) 585-6616
            </div>
          </div>
        </aside>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "Services",
  metaInfo: {
    title: "Our Services",
  },
};
</script>